import { render, staticRenderFns } from "./PlansV4.vue?vue&type=template&id=622d31d8&"
import script from "./PlansV4.vue?vue&type=script&lang=js&"
export * from "./PlansV4.vue?vue&type=script&lang=js&"
import style0 from "./PlansV4.vue?vue&type=style&index=0&id=622d31d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports